import { AuthActionCreators, IGet } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { useEffect, useState } from 'react';

export interface ICoachListItem {
    id: number;
    contactId: number | null;
    firstName: string;
    lastName: string;
}

interface IRetVal {
    coachList: ICoachListItem[];
    getCoachName: (coachId: number) => string;
    loading: boolean;
    error: string;
}

let cache: ICoachListItem[] | null = null;

const useCoachList = (): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [coachList, setCoachList] = useState<ICoachListItem[]>(cache ?? []);

    useEffect(() => {
        if (cache) {
            return;
        }

        setLoading(true);
        setError('');

        const config: IGet = {
            url: `${__API__}/microsite/coach/list`
        };

        const fetchData = async () => {
            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {
                    cache = response.data.results;
                    setCoachList(cache);
                } else {
                    setError('Unable to load coach list');
                }
            } catch (err) {
                setError(err?.message ?? 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const getCoachName = (coachId: number): string => {
        const coach = coachList.find(c => c.contactId === coachId);
        return coach ? `${coach.firstName} ${coach.lastName}` : 'All Coaches';
    };

    return { coachList, getCoachName, loading, error };
}

export default useCoachList;
